import { LOCATION_LITE_COOKIE_EXPIRATION_FROMNOW } from '../constants.esm.js';

/**
 * Get an expiration date 1 yr from now
 */
var getCookieExpiration = function (expireFromNow) {
    if (expireFromNow === void 0) { expireFromNow = LOCATION_LITE_COOKIE_EXPIRATION_FROMNOW; }
    return new Date(Date.now() + expireFromNow);
};

export { getCookieExpiration };
//# sourceMappingURL=expiration.esm.js.map
